import { useMemo } from 'react';

import {
  resolveFinishRegistry,
  type MapEditorFinishRegistry,
} from './mapEditorFinishes';
import { useMapEditorCatalog } from './useMapEditorCatalog';

/**
 * The runtime-finish registry of the kit this map's build shipped.
 *
 * Read off the catalog useMapEditorCatalog resolved, rather than reaching for the build record a
 * second time. The schema and the elements have to come from one read: the hub's bounds are the only
 * clamp there is on a preview, so a schema read separately from the elements it clamps could let a
 * slider run past what the streaming build accepts. Since MV-2004 there is only one candidate
 * catalog — the streamed build's own — which makes this a cheap invariant rather than a choice.
 *
 * @returns The registry, empty on a build that ships no finishes.
 */
export const useMapEditorFinishRegistry = (): MapEditorFinishRegistry => {
  const { catalog } = useMapEditorCatalog();

  return useMemo(() => resolveFinishRegistry(catalog), [catalog]);
};
